"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.abTests = void 0;
exports.abTests = {
    WELCOME_PAGE_APP: {
        kind: "multiple",
        variants: ["versionA", "versionB"],
    },
    PAYWALL: {
        kind: "multiple",
        variants: ["versionA", "versionB"],
    },
    SKIP_PAYWALL: {
        kind: "single",
    },
    ENABLE_PLACEMENT_TEST: {
        kind: "single",
    },
    WHATSAPP_V3: {
        kind: "single",
    },
};
//# sourceMappingURL=abTests.utils.js.map